export const FETCH_RESOURCE_PERMISSIONS_REQUEST       = 'resource-permissions/fetch/request';
export const FETCH_RESOURCE_PERMISSIONS_SUCCESS       = 'resource-permissions/fetch/success';
export const FETCH_RESOURCE_PERMISSIONS_FAIL          = 'resource-permissions/fetch/fail';

